export const translations = {
  es: {
    // Navbar
    'nav.home': 'Inicio',
    'nav.catalog': 'Catálogo',
    'nav.downloads': 'Documentación',
    'nav.company': 'Empresa',
    'nav.solutions': 'Soluciones',
    'nav.seeAll': 'Ver todas',

    // Footer
    'footer.desc':
      'SmartImport Internacional se especializa en la importación y distribución de materiales arquitectónicos para distribuidores profesionales y proyectos de construcción.',
    'footer.nav': 'Navegación',
    'footer.products': 'Líneas de Producto',
    'footer.rights':
      'SmartImport Internacional. Todos los derechos reservados.',
    'footer.privacy': 'Política de privacidad',
    'footer.terms': 'Términos de uso',
    'footer.legal': 'Aviso legal',
    'footer.cookies': 'Política de cookies',

    // Home
    'home.hero.title': 'Materiales arquitectónicos para distribuidores',
    'home.hero.desc':
      'Desarrollamos, fabricamos e importamos materiales para empresas que desean ampliar o crear su propia línea de productos.',
    'home.hero.cta': 'Explorar catálogo',
    'home.hero.scroll': 'Descubrir',
    'home.solutions.title': 'Nuestras Soluciones',
    'home.solutions.floor.desc': 'Suelos SPC y tarimas técnicas',
    'home.solutions.panel.desc': 'Paneles decorativos y revestimientos',
    'home.solutions.door.desc': 'Puertas WPC y soluciones de acceso',
    'home.solutions.strips.desc':
      'Paneles, tiras y revestimientos para interior y exterior',
    'home.solutions.sofa.desc': 'Sofás compactos autoexpandibles',
    'home.solutions.machinery.desc': 'Elevadores eléctricos y montacargas',
    'home.solutions.garden.desc': 'Césped artificial y paisajismo exterior',
    'home.solutions.details': 'Ver detalles',
    'home.apps.title': 'Aplicaciones y Proyectos',
    'home.apps.desc':
      'Nuestros materiales están diseñados para adaptarse a las exigencias de cualquier entorno, ofreciendo durabilidad y estética superior.',
    'home.apps.hotels': 'Hoteles',
    'home.apps.offices': 'Oficinas',
    'home.apps.residential': 'Residencial',
    'home.apps.commercial': 'Espacios comerciales',
    'home.catalog.title': 'Catálogo de Materiales',
    'home.catalog.desc':
      'Explore nuestra extensa colección de muestras, texturas y acabados. Diseñados para inspirar y materializar su visión arquitectónica con la más alta calidad.',
    'home.catalog.cta': 'Ver catálogo completo',
    'home.why.title': '¿Por qué SmartImport?',
    'home.why.q1.title': 'Alta calidad',
    'home.why.q1.desc': 'Estándares premium en cada material.',
    'home.why.q2.title': 'Materiales innovadores',
    'home.why.q2.desc': 'Últimas tendencias en diseño y tecnología.',
    'home.why.q3.title': 'Distribución internacional',
    'home.why.q3.desc': 'Logística global eficiente y segura.',
    'home.why.q4.title': 'Soluciones profesionales',
    'home.why.q4.desc': 'Asesoramiento experto para su proyecto.',

    // Brand Development Section
    'home.brand.title': 'Desarrollo de marca y fabricación',
    'home.brand.desc':
      'En SmartImport no solo desarrollamos nuestras propias líneas de productos. También colaboramos con distribuidores y empresas que desean crear o ampliar sus propias marcas mediante fabricación e importación directa con fabricantes especializados.',
    'home.brand.b1.title': 'Fabricación personalizada',
    'home.brand.b1.desc':
      'Producción adaptada a las necesidades del cliente mediante fabricantes especializados en materiales arquitectónicos.',
    'home.brand.b2.title': 'Creación de marca',
    'home.brand.b2.desc':
      'Desarrollo de identidad de marca, packaging y catálogo para crear líneas de producto con marca propia.',
    'home.brand.b3.title': 'Importación y logística',
    'home.brand.b3.desc':
      'Gestión completa del proceso desde la fabricación hasta la entrega en el destino final.',

    // How We Work Section
    'home.how.title': 'Cómo trabajamos',
    'home.how.desc':
      'Gestionamos todo el proceso de importación y logística para distribuidores de materiales arquitectónicos.',
    'home.how.s1.title': 'Recepción de pedidos',
    'home.how.s1.desc':
      'Recibimos pedidos y coordinamos la producción con fabricantes especializados.',
    'home.how.s2.title': 'Almacenamiento',
    'home.how.s2.desc':
      'Gestionamos el almacenamiento y organización de materiales en centros logísticos modernos.',
    'home.how.s3.title': 'Control de calidad',
    'home.how.s3.desc':
      'Cada lote de materiales es inspeccionado para garantizar estándares internacionales.',
    'home.how.s4.title': 'Preparación de pedidos',
    'home.how.s4.desc':
      'Preparamos y embalamos productos como suelo SPC, paneles decorativos y perfiles para distribución.',
    'home.how.s5.title': 'Envío internacional',
    'home.how.s5.desc':
      'Coordinamos envíos globales mediante contenedores y logística internacional eficiente.',

    // Distributor Solutions Section
    'home.dist.title': 'Soluciones para distribuidores',
    'home.dist.desc':
      'SmartImport colabora con distribuidores, tiendas especializadas y empresas que buscan ampliar o desarrollar nuevas líneas de productos mediante fabricación e importación directa.',
    'home.dist.p1': 'Desarrollo de líneas de producto personalizadas',
    'home.dist.p2': 'Fabricación con marca propia (private label)',
    'home.dist.p3': 'Importación y distribución internacional',
    'home.dist.partner.title': 'Partner de confianza',
    'home.dist.partner.desc':
      'Trabajamos como una extensión de su equipo, ofreciendo soporte técnico, desarrollo de producto y gestión logística integral.',

    // Product Pages - Technical Documentation
    'prod.docs.title': 'Documentación Técnica',
    'prod.docs.download': 'Descargar PDF',
    'prod.docs.soon': 'Próximamente',
    'prod.docs.floor.desc':
      'Accede a catálogos y fichas técnicas del sistema SmartFloor SPC.',
    'prod.docs.panel.desc':
      'Accede a catálogos y fichas técnicas de la línea SmartPanel.',
    'prod.docs.door.desc':
      'Accede a catálogos y fichas técnicas de la línea SmartDoor.',
    'prod.docs.alum.desc':
      'Accede a catálogos y fichas técnicas de la línea SmartAluminium.',
    'prod.docs.catalogs': 'Catálogos',
    'prod.docs.techDocs': 'Documentación Técnica',
    'prod.docs.techSheets': 'Fichas técnicas',
    'prod.docs.count.one': 'documento',
    'prod.docs.count.many': 'documentos',

    // SmartPanel Materials Section
    'prod.docs.panel.title': 'Materiales SmartPanel',
    'prod.docs.panel.materials.desc':
      'Accede a catálogos, fichas técnicas y certificados de cada material.',
    'panel.pvc.name': 'SmartPanel PVC',
    'panel.pvc.desc':
      'Panel decorativo ligero y versátil, ideal para múltiples aplicaciones interiores.',
    'panel.spc.name': 'SmartPanel SPC',
    'panel.spc.desc':
      'Panel de alta resistencia con gran estabilidad, perfecto para espacios exigentes.',
    'panel.bambu.name': 'SmartPanel Bambú',
    'panel.bambu.desc':
      'Panel ecológico con acabado natural, incluye soluciones en carbón de bambú.',
    'panel.piedra.name': 'SmartPanel Piedra Sinterizada',
    'panel.piedra.desc':
      'Panel de máxima resistencia con acabado premium tipo porcelánico.',
    'panel.pvc.cat1': 'Classic Series Glossy PVC Marble 2024',
    'panel.pvc.cat2': 'Gilded Series Glossy PVC Marble 2024',
    'panel.pvc.cat3': 'Luxury Series Glossy PVC Marble 2024',
    'panel.pvc.cat4': 'Matte Collection Vol. 1',
    'panel.pvc.cat5': 'Matte Collection Vol. 2',
    'panel.pvc.tech1': 'SmartPanel PVC – Ficha Técnica 4mm',
    'panel.bambu.cat1': 'Bambú Collection Vol. 1',
    'panel.bambu.cat2': 'Bambú Collection Vol. 2',
    'panel.bambu.cat3': 'Bambú Premium Designs',
    'panel.bambu.cat4': 'Bambú Natural Series',
    'panel.bambu.cat5': 'Bambú Interior Collection',
    'panel.bambu.cat6': 'Bambú Modern Line',
    'panel.bambu.cat7': 'Bambú Architectural Systems',
    'panel.bambu.cat8': 'Bambú Decorative Panels',
    'panel.bambu.cat9': 'Bambú Technical Overview',
    'panel.bambu.cat10': 'Bambú Installation Guide',
    'panel.bambu.cat11': 'Bambú Specifications Sheet',
    'panel.bambu.cat12': 'Bambú Luxury Stone Collection',
    'panel.bambu.tech1': 'Ficha Técnica Bambú',
    'panel.piedra.cat1': 'Sintered Stone – Full Collection 2025',
    'panel.piedra.cat2': 'Sintered Stone – Glossy Finish',
    'panel.piedra.cat3': 'Sintered Stone – Matte Finish',
    'panel.piedra.cat4': 'Sintered Stone – Soft Touch Finish',
    'panel.piedra.cat5': 'Sintered Stone – Textured Surface',
    'panel.piedra.cat6': 'Sintered Stone – Digital Surface',
    'panel.piedra.tech1': 'Documentación Técnica',

    // SmartStrips Documentation Section
    'prod.docs.strips.title': 'Documentación SmartPanel Exterior & Decorativo',
    'prod.docs.strips.desc':
      'Accede a catálogos y fichas técnicas de paneles, tiras y revestimientos.',
    'strips.cat1': 'Tiras Decorativas – 1º Catálogo',
    'strips.cat2': 'Tiras Decorativas – 2º Catálogo',
    'strips.cat3': 'Tiras Decorativas – Catálogo Luxury',
    'strips.tech1': 'Tiras Decorativas – Ficha Técnica',

    // SmartMachinery Documentation Section
    'prod.docs.machinery.title': 'Documentación SmartMachinery',
    'prod.docs.machinery.desc':
      'Accede a catálogos y documentación técnica de SmartMachinery.',
    'machinery.cat1': 'Catálogo de Montacargas Eléctricos',

    // SmartSofa Documentation Section
    'prod.docs.sofa.title': 'Documentación SmartSofa',
    'prod.docs.sofa.desc':
      'Accede a catálogos y documentación técnica de SmartSofa.',
    'sofa.cat1': 'Catálogo Colección SmartSofa',

    // Solutions Page
    'sol.hero.title': 'Líneas de Producto',
    'sol.hero.desc':
      'Soluciones integrales para proyectos arquitectónicos exigentes.',
    'sol.floor.desc':
      'Suelos de última generación que combinan la belleza natural con una resistencia extrema. Ideales para zonas de alto tránsito, resistentes al agua y de fácil instalación.',
    'sol.panel.desc':
      'Revestimientos de pared innovadores que transforman espacios rápidamente. Ofrecen aislamiento acústico, resistencia al fuego y una amplia variedad de acabados estéticos.',
    'sol.door.desc':
      'Puertas de interior y exterior fabricadas con compuestos de madera y polímeros. Garantizan durabilidad frente a la humedad, diseño moderno y excelente aislamiento térmico.',
    'sol.strips.desc':
      'Soluciones decorativas y revestimientos arquitectónicos para interiores y exteriores, incluyendo paneles PS, tiras decorativas y sistemas WPC de alta durabilidad.',
    'sol.sofa.desc':
      'SmartSofa es una solución innovadora de asientos diseñada para la comodidad y la practicidad. Cada sofá se entrega en un paquete compacto y se expande a su forma completa en pocas horas. Combina diseño moderno y facilidad de montaje.',
    'sol.machinery.desc':
      'SmartMachinery ofrece sistemas de elevación eléctrica fiables, diseñados para transportar mercancías de forma eficiente entre diferentes niveles. Nuestras soluciones soportan diversas capacidades de carga, incluyendo 2000 kg, 3000 kg y 4000 kg, ideales para almacenes, centros logísticos e instalaciones comerciales.',
    'sol.garden.desc':
      'Soluciones para exterior y paisajismo con césped artificial de alta calidad. Ideales para jardines, terrazas, áreas recreativas y espacios comerciales que requieren un acabado natural sin mantenimiento.',
    'sol.explore': 'Explorar línea completa',

    // Catalog Page
    'cat.hero.title': 'Catálogo de Materiales',
    'cat.hero.desc': 'Explore nuestra selección de acabados premium.',
    'cat.download.btn': 'Descargar catálogo',
    'cat.c1.title': 'Luxury Series',
    'cat.c1.desc':
      'Colección de paneles decorativos PVC efecto mármol brillante para interiores premium.',
    'cat.c2.title': 'Classic Series',
    'cat.c2.desc':
      'Colección clásica de paneles PVC efecto mármol para proyectos residenciales y comerciales.',
    'cat.c3.title': 'Matte Series',
    'cat.c3.desc':
      'Paneles decorativos con acabado mate inspirados en piedra natural para interiores contemporáneos.',
    'cat.c4.title': 'Gold Series',
    'cat.c4.desc':
      'Paneles decorativos efecto mármol con vetas doradas para proyectos arquitectónicos exclusivos.',
    'cat.c5.title': 'Matte Collection II',
    'cat.c5.desc':
      'Colección de paneles decorativos con acabados mate y texturas inspiradas en mármol natural.',
    'cat.c16.title': 'Bambú Collection',
    'cat.c16.desc':
      'Colección ecológica de paneles de bambú con acabados naturales para interiores sostenibles.',
    'cat.c17.title': 'Sintered Stone Collection',
    'cat.c17.desc':
      'Paneles de piedra sinterizada de alta resistencia con acabados premium tipo porcelánico.',
    'cat.tabs.all': 'Todos',
    'cat.tabs.smartpanel': 'SmartPanel',
    'cat.tabs.smartstrips': 'SmartPanel Exterior & Decorativo',
    'cat.tabs.smartfloor': 'SmartFloor',
    'cat.tabs.smartdoor': 'SmartDoor',
    'cat.tabs.smartsofa': 'SmartSofa',
    'cat.tabs.smartmachinery': 'SmartMachinery',
    'cat.tabs.smartgarden': 'SmartGarden',
    'cat.c6.title': 'Decorative Wall Slats Collection',
    'cat.c6.desc':
      'Colección de tiras decorativas para paredes interiores con diseño lineal moderno. Ideales para crear paredes arquitectónicas elegantes en espacios residenciales y comerciales.',
    'cat.c7.title': 'PS Interior Wall Systems',
    'cat.c7.desc':
      'Sistema moderno de paneles decorativos PS para revestimiento de paredes interiores y superficies arquitectónicas contemporáneas. Diseñado para proyectos residenciales y comerciales con acabados premium y estética moderna.',
    'cat.c8.title': 'SmartFloor SPC Static Pro',
    'cat.c8.desc':
      'Sistema de suelo SPC mineral de alta resistencia, 100% impermeable y diseñado para espacios residenciales y comerciales modernos.',
    'cat.c9.title': 'SPC New Designs Collection',
    'cat.c9.desc':
      'Colección de nuevos diseños de suelos SPC con acabados de madera natural y alto rendimiento para proyectos de arquitectura interior.',
    'cat.c10.title': 'SmartDoor WPC Waterproof',
    'cat.c10.desc':
      'Puertas interiores WPC de alto rendimiento, 100% impermeables, antihumedad y resistentes al fuego. Diseñadas para proyectos residenciales y comerciales con estética moderna y gran durabilidad.',
    'cat.c18.title': 'Puertas Blindadas',
    'cat.c18.desc':
      'Puertas de alta seguridad con estructura reforzada, diseño moderno y acabados premium. Ideales para accesos principales en viviendas y proyectos residenciales.',
    'cat.c19.title': 'PS Decorative Mouldings',
    'cat.c19.desc':
      'Molduras decorativas PS para acabados interiores modernos, ideales para crear detalles elegantes y revestimientos arquitectónicos contemporáneos en proyectos residenciales y comerciales.',
    'cat.c20.title': 'WPC Exterior Decking',
    'cat.c20.desc':
      'Sistema premium de tarimas y superficies exteriores WPC diseñado para terrazas, fachadas, piscinas y proyectos arquitectónicos contemporáneos. Alta resistencia, estética moderna y acabados exteriores de lujo para aplicaciones residenciales y comerciales.',
    'cat.c21.title': 'PS Decorative Wall Panels',
    'cat.c21.desc':
      'Colección premium de paneles decorativos PS para revestimiento de paredes interiores con diseños tridimensionales y acabados arquitectónicos modernos. Ideal para proyectos residenciales y comerciales de alta gama.',
    'cat.c22.title': 'PS Wall Panel Catalog',
    'cat.c22.desc':
      'Sistema premium de paneles decorativos PS para revestimientos interiores y aplicaciones arquitectónicas modernas con acabados elegantes y diseño contemporáneo.',
    'cat.c11.title': 'SmartAluminium Window Systems',
    'cat.c11.desc':
      'Sistemas de ventanas y puertas de aluminio de alto rendimiento con perfiles minimalistas, doble acristalamiento y excelente aislamiento térmico y acústico. Diseñados para arquitectura moderna en viviendas, oficinas y proyectos comerciales.',
    'cat.c12.title': 'SmartGarden Artificial Grass',
    'cat.c12.desc':
      'Césped artificial de alta calidad diseñado para jardines, terrazas y espacios exteriores. Apariencia natural, alta durabilidad y mínimo mantenimiento para proyectos residenciales y comerciales.',
    'cat.c13.title': 'SmartSofa',
    'cat.c13.desc':
      'Sofás modulares de diseño premium con sistemas expansibles, pensados para maximizar el confort y la funcionalidad en espacios modernos.',
    'cat.c14.title': 'SmartMachinery',
    'cat.c14.desc':
      'Equipos de elevación como montacargas eléctricos y plataformas hidráulicas, diseñados para el manejo eficiente de mercancías en entornos industriales.',
    'cat.c15.title': 'SmartGarden',
    'cat.c15.desc':
      'Césped artificial y soluciones decorativas para exteriores, diseñadas para ofrecer durabilidad, estética natural y bajo mantenimiento.',
    'cat.coming.soon': 'Próximamente',
    'cat.viewAll.btn': 'Ver todos los catálogos',
    'cat.viewAll.subtitle':
      'Explora todas las colecciones y documentación técnica completa',
    'cat.sample': 'Muestra Material',
    'cat.item1.name': 'Roble Natural SPC',
    'cat.item1.desc': 'Acabado madera mate, 5mm',
    'cat.item2.name': 'Nogal Oscuro SPC',
    'cat.item2.desc': 'Textura sincronizada, 6mm',
    'cat.item3.name': 'Piedra Caliza SPC',
    'cat.item3.desc': 'Efecto piedra natural, gran formato',
    'cat.item4.name': 'Panel Acústico Listonado',
    'cat.item4.desc': 'Madera sobre fieltro PET',
    'cat.item5.name': 'Revestimiento 3D Ondas',
    'cat.item5.desc': 'Acabado lacado blanco mate',
    'cat.item6.name': 'Puerta WPC Lisa Blanca',
    'cat.item6.desc': 'Núcleo macizo, resistente al agua',
    'cat.item7.name': 'Puerta WPC Textura Madera',
    'cat.item7.desc': 'Acabado roble con marco a juego',
    'cat.item8.name': 'Perfilería Minimalista Negra',
    'cat.item8.desc': 'Anodizado negro mate, serie 45',
    'cat.item9.name': 'División de Oficina Cristal',
    'cat.item9.desc': 'Perfil oculto, doble acristalamiento',
    'cat.item10.name': 'Césped Premium 40mm',
    'cat.item10.desc': 'Alta densidad, aspecto natural',
    'cat.item11.name': 'Césped Deportivo 25mm',
    'cat.item11.desc': 'Resistente al tránsito intenso',
    'cat.item12.name': 'Césped Paisajismo 35mm',
    'cat.item12.desc': 'Suave al tacto, drenaje integrado',
    'cat.item15.name': 'Puerta WPC Negra',
    'cat.item15.desc': 'Acabado negro elegante, núcleo macizo',
    'cat.item16.name': 'Sistema Marco Slim',
    'cat.item16.desc': 'Perfil ultra delgado, máxima luminosidad',

    // Downloads Page
    'dl.hero.title': 'Documentación',
    'dl.hero.desc':
      'Centro de documentación técnica para distribuidores y arquitectos. Acceda a fichas técnicas, guías de instalación y certificados de nuestros productos.',
    'dl.sec1.title': 'Fichas Técnicas',
    'dl.sec1.desc':
      'Documentación técnica con especificaciones, medidas, materiales y rendimiento de los productos.',
    'dl.sec1.i1': 'Ficha técnica SPC Static Pro',
    'dl.sec1.i2': 'Especificaciones Puertas WPC',
    'dl.sec1.i3': 'Perfiles de Aluminio – Detalles',
    'dl.sec1.i4': 'Clasificación Antideslizante R11',
    'dl.sec1.i5': 'Ficha técnica Zócalo SPC',
    'dl.sec2.title': 'Guías de Instalación',
    'dl.sec2.desc':
      'Manuales técnicos para la correcta instalación de los sistemas y materiales.',
    'dl.sec2.i1': 'Guía de instalación de paneles',
    'dl.sec2.i2': 'Manual de instalación SPC',
    'dl.sec2.i3': 'Manual de instalación WPC',
    'dl.panel.pvc.tech1': 'Ficha técnica PVC 4mm',
    'dl.panel.bambu.tech1': 'Ficha técnica panel bambú 3 capas',
    'dl.panel.bambu.tech2': 'Ficha técnica producto 4mm',
    'dl.door.wpc.cert1': 'Certificado de garantía puertas WPC',
    'dl.door.wpc.tech1': 'Ficha técnica puertas WPC',
    'dl.door.wpc.tech2': 'Ficha técnica WPC puerta',
    'dl.door.blindada.tech1': 'Ficha técnica puerta blindada',
    'dl.strips.tech1': 'Ficha técnica zócalo PS',
    'dl.strips.tech2': 'Hoja de datos panel mural PS',
    'dl.sec3.title': 'Certificados y Garantías',
    'dl.sec3.desc':
      'Certificados de calidad, normativas y garantías de los productos.',
    'dl.sec3.i1': 'Certificado de resistencia al fuego',
    'dl.sec3.i2': 'Certificación ISO 9001',
    'dl.sec3.i3': 'Garantía SmartFloor 25 años',
    'dl.btn': 'Descargar',

    // About Page
    'about.hero.title': 'Sobre SmartImport',
    'about.hero.desc':
      'Especialistas en la importación y distribución internacional de materiales arquitectónicos de vanguardia.',
    'about.vision.title': 'Nuestra Visión',
    'about.vision.p1':
      'SmartImport Internacional nace con el propósito de conectar los proyectos arquitectónicos más exigentes con soluciones materiales innovadoras a nivel global. Nos especializamos en la importación y distribución de productos de alta gama, incluyendo puertas WPC, suelos SPC, paneles decorativos y sistemas de aluminio.',
    'about.vision.p2':
      'Entendemos que la arquitectura contemporánea requiere materiales que no solo cumplan con los más altos estándares estéticos, sino que también ofrezcan un rendimiento técnico superior, durabilidad y facilidad de instalación.',
    'about.vision.p3':
      'Nuestro equipo de expertos selecciona cuidadosamente cada línea de producto, asegurando que cumplan con rigurosas normativas internacionales de calidad y sostenibilidad, para ofrecer a arquitectos, constructores y diseñadores las herramientas necesarias para materializar su visión.',
    'about.pillars.title': 'Nuestros Pilares',
    'about.pillars.desc':
      'Los valores que guían nuestra operación y garantizan la excelencia en cada entrega.',
    'about.pil1.title': 'Innovación',
    'about.pil1.desc':
      'Búsqueda constante de nuevos materiales y tecnologías constructivas.',
    'about.pil2.title': 'Calidad',
    'about.pil2.desc':
      'Estrictos controles y certificaciones en todos nuestros productos.',
    'about.pil3.title': 'Alcance Global',
    'about.pil3.desc': 'Red de distribución internacional eficiente y segura.',
    'about.pil4.title': 'Servicio Profesional',
    'about.pil4.desc':
      'Asesoramiento técnico especializado para cada proyecto.',

    // Product Pages Common
    'prod.line': 'Línea de Producto',
    'prod.adv.title': 'Ventajas Principales',
    'prod.dl.btn': 'Descargar Catálogo Técnico',

    // SmartFloor
    'floor.hero.desc': 'Suelos SPC y tarimas técnicas de alto rendimiento.',
    'floor.sec.title': 'Innovación bajo sus pies',
    'floor.sec.p1':
      'La línea SmartFloor representa la evolución en pavimentos. Fabricados con tecnología SPC (Stone Plastic Composite), nuestros suelos ofrecen una estabilidad dimensional superior y una resistencia inigualable frente a impactos y arañazos.',
    'floor.sec.p2':
      'Ideales tanto para renovaciones rápidas como para obra nueva, proporcionan el aspecto cálido de la madera o la elegancia de la piedra con las ventajas técnicas de los materiales compuestos de última generación.',
    'floor.adv1': 'Alta durabilidad y resistencia al desgaste',
    'floor.adv2': '100% resistente al agua y humedad',
    'floor.adv3': 'Instalación rápida mediante sistema click',
    'floor.adv4': 'Amplia variedad de diseños y texturas realistas',
    'floor.adv5': 'Fácil mantenimiento y limpieza',
    'floor.adv6': 'Compatible con suelo radiante',
    'floor.app1.title': 'Residencial',
    'floor.app1.desc': 'Salones, cocinas y baños con un acabado impecable.',
    'floor.app2.title': 'Comercial',
    'floor.app2.desc': 'Locales, oficinas y hoteles con alto tránsito.',

    // SmartFloor Technical Specs
    'floor.specs.title': 'Características técnicas del sistema SmartFloor SPC',
    'floor.specs.intro':
      'El sistema SmartFloor SPC ha sido diseñado para ofrecer alta resistencia, estabilidad dimensional y durabilidad en aplicaciones residenciales y comerciales. Fabricado con tecnología SPC (Stone Plastic Composite), combina estética natural con alto rendimiento técnico.',
    'floor.specs.features.title': 'Características destacadas',
    'floor.specs.f1': '100% impermeable, resistente al agua y la humedad',
    'floor.specs.f2':
      'Alta resistencia al desgaste para zonas de alto tránsito',
    'floor.specs.f3': 'Superficie antideslizante para mayor seguridad',
    'floor.specs.f4':
      'Alta estabilidad dimensional frente a cambios de temperatura',
    'floor.specs.f5': 'Fácil mantenimiento y limpieza',
    'floor.specs.f6': 'Apto para aplicaciones residenciales y comerciales',
    'floor.specs.table.title': 'Especificaciones técnicas',
    'floor.specs.table.col1': 'Característica',
    'floor.specs.table.col2': 'Especificación',
    'floor.specs.t1.label': 'Tipo de suelo',
    'floor.specs.t1.value': 'SPC (Stone Plastic Composite)',
    'floor.specs.t2.label': 'Impermeabilidad',
    'floor.specs.t2.value': '100% resistente al agua',
    'floor.specs.t3.label': 'Resistencia al desgaste',
    'floor.specs.t3.value': 'Grupo de desgaste T',
    'floor.specs.t4.label': 'Resistencia al deslizamiento',
    'floor.specs.t4.value': 'R9',
    'floor.specs.t5.label': 'Estabilidad dimensional',
    'floor.specs.t5.value': 'Alta estabilidad frente a expansión o contracción',
    'floor.specs.t6.label': 'Resistencia química',
    'floor.specs.t6.value': 'No afectado por más de 35 productos químicos',
    'floor.specs.t7.label': 'Resistencia al calor',
    'floor.specs.t7.value': 'Sin deformación tras exposición al calor',
    'floor.specs.t8.label': 'Emisiones químicas (VOC)',
    'floor.specs.t8.value': 'Cumple estándar CDPH/EHLB',
    'floor.specs.t9.label': 'Resistencia al fuego',
    'floor.specs.t9.value': 'Cumple normativa EN ISO',
    'floor.specs.t10.label': 'Uso recomendado',
    'floor.specs.t10.value': 'Aplicaciones residenciales y comerciales',

    // SmartPanel
    'panel.hero.desc': 'Paneles decorativos y revestimientos arquitectónicos.',
    'panel.sec.title': 'Transformación visual inmediata',
    'panel.sec.p1':
      'SmartPanel redefine el diseño de interiores ofreciendo soluciones de revestimiento mural que combinan estética premium con funcionalidad técnica. Nuestros paneles permiten renovar espacios comerciales y residenciales en tiempo récord, evitando obras complejas.',
    'panel.sec.p2':
      'Desde acabados en madera natural hasta texturas pétreas y diseños tridimensionales, la colección proporciona a arquitectos y diseñadores una herramienta versátil para crear atmósferas únicas.',
    'panel.adv1': 'Versatilidad estética con múltiples texturas',
    'panel.adv2': 'Instalación rápida sobre paredes existentes',
    'panel.adv3': 'Propiedades de aislamiento acústico',
    'panel.adv4': 'Resistencia al fuego (certificación B-s1,d0)',
    'panel.adv5': 'Fácil mantenimiento y limpieza',
    'panel.adv6': 'Material ligero pero altamente resistente',
    'panel.app1.title': 'Hostelería',
    'panel.app1.desc':
      'Lobbies, habitaciones y restaurantes con diseño exclusivo.',
    'panel.app2.title': 'Corporativo',
    'panel.app2.desc': 'Salas de reuniones y recepciones de alto impacto.',

    // SmartDoor
    'door.hero.desc': 'Puertas WPC y soluciones de acceso avanzadas.',
    'door.sec.title': 'Accesos que marcan la diferencia',
    'door.sec.p1':
      'Las puertas SmartDoor, fabricadas en WPC (Wood Plastic Composite), representan la alternativa definitiva a las puertas tradicionales de madera. Combinan la calidez estética con una resistencia estructural superior, siendo totalmente inmunes a la humedad y a los xilófagos.',
    'door.sec.p2':
      'Su núcleo sólido proporciona un excelente aislamiento acústico, haciéndolas ideales para proyectos hoteleros, residenciales y hospitalarios donde el confort y la durabilidad son prioritarios.',
    'door.adv1': '100% resistentes al agua y la humedad',
    'door.adv2': 'Alta durabilidad y resistencia a impactos',
    'door.adv3': 'Excelente aislamiento térmico y acústico',
    'door.adv4': 'Diseños modernos y minimalistas',
    'door.adv5': 'No requieren mantenimiento complejo',
    'door.adv6': 'Ecológicas y reciclables',
    'door.app1.title': 'Hospitalario',
    'door.app1.desc': 'Entornos exigentes que requieren higiene y resistencia.',
    'door.app2.title': 'Residencial',
    'door.app2.desc': 'Baños y zonas húmedas sin riesgo de deterioro.',

    // SmartStrips
    'strips.hero.desc':
      'Soluciones decorativas y revestimientos para interiores y exteriores.',
    'strips.sec.title': 'Revestimientos que transforman espacios',
    'strips.sec.p1':
      'Nuestra línea de soluciones decorativas abarca desde tiras interiores y paneles PS hasta tarimas WPC y revestimientos arquitectónicos para exteriores. Proporcionan una estética moderna siendo fáciles de instalar y mantener, ideales para cualquier entorno.',
    'strips.sec.p2':
      'Disponibles en una amplia gama de acabados y materiales, estas soluciones permiten crear composiciones únicas que aportan profundidad, textura y personalidad tanto en interiores como en fachadas y espacios al aire libre.',
    'strips.adv1': 'Instalación rápida y sencilla',
    'strips.adv2': 'Amplia variedad de acabados y colores',
    'strips.adv3': 'Resistentes a la humedad y al desgaste',
    'strips.adv4': 'Soluciones para interior y exterior',
    'strips.adv5': 'Mantenimiento mínimo',
    'strips.adv6': 'Sistemas WPC de alta durabilidad',
    'strips.app1.title': 'Interior Decorativo',
    'strips.app1.desc':
      'Paneles PS y tiras para salones, dormitorios y espacios de diseño.',
    'strips.app2.title': 'Exterior Arquitectónico',
    'strips.app2.desc':
      'Tarimas WPC y revestimientos para fachadas, terrazas y espacios comerciales.',

    // SmartSofa
    'sofa.hero.desc': 'Sofás compactos con sistema autoexpandible.',
    'sofa.sec.title': 'Confort inteligente',
    'sofa.sec.p1':
      'SmartSofa es una solución innovadora de asientos diseñada para la comodidad y la practicidad. Cada sofá se entrega en un paquete compacto y se expande a su forma completa en pocas horas tras el desembalaje.',
    'sofa.sec.p2':
      'Combina practicidad, diseño moderno y facilidad de montaje, siendo ideal para espacios de vida contemporáneos. Sin herramientas, sin complicaciones, solo confort inmediato.',
    'sofa.adv1': 'Sistema autoexpandible sin herramientas',
    'sofa.adv2': 'Entrega en paquete compacto',
    'sofa.adv3': 'Diseño moderno y ergonómico',
    'sofa.adv4': 'Materiales de alta calidad y durabilidad',
    'sofa.adv5': 'Fácil limpieza y mantenimiento',
    'sofa.adv6': 'Ideal para espacios contemporáneos',
    'sofa.app1.title': 'Residencial',
    'sofa.app1.desc': 'Salones y espacios de estar modernos.',
    'sofa.app2.title': 'Hospitality',
    'sofa.app2.desc': 'Hoteles, apartamentos turísticos y coworking.',

    // SmartMachinery
    'machinery.hero.desc':
      'Elevadores eléctricos de carga para uso industrial y comercial.',
    'machinery.sec.title': 'Elevación eficiente y segura',
    'machinery.sec.p1':
      'SmartMachinery ofrece sistemas de elevación eléctrica fiables, diseñados para transportar mercancías de forma eficiente entre diferentes niveles. Nuestras soluciones soportan diversas capacidades de carga, incluyendo 2000 kg, 3000 kg y 4000 kg.',
    'machinery.sec.p2':
      'Ideales para almacenes, centros logísticos e instalaciones comerciales, nuestros montacargas combinan robustez industrial con facilidad de instalación y mantenimiento.',
    'machinery.adv1': 'Alta capacidad de carga (2000–4000 kg)',
    'machinery.adv2': 'Funcionamiento suave y seguro',
    'machinery.adv3': 'Durabilidad de grado industrial',
    'machinery.adv4': 'Fácil instalación y mantenimiento',
    'machinery.adv5': 'Sistemas eléctricos eficientes',
    'machinery.adv6': 'Cumplimiento de normativas de seguridad',
    'machinery.app1.title': 'Industrial',
    'machinery.app1.desc': 'Almacenes, fábricas y centros logísticos.',
    'machinery.app2.title': 'Comercial',
    'machinery.app2.desc':
      'Centros comerciales, hoteles y edificios de oficinas.',

    // SmartGarden
    'garden.hero.desc':
      'Soluciones para exterior y paisajismo con césped artificial de alta calidad.',
    'garden.sec.title': 'Naturaleza sin mantenimiento',
    'garden.sec.p1':
      'La línea SmartGarden ofrece césped artificial de última generación, diseñado para replicar la apariencia y textura del césped natural con una durabilidad excepcional. Fabricado con fibras de polietileno de alta densidad, nuestro césped resiste la radiación UV, el tránsito intenso y las condiciones climáticas más exigentes.',
    'garden.sec.p2':
      'Ideal para jardines residenciales, terrazas, áreas de juego infantil, instalaciones deportivas y espacios comerciales. Proporciona un acabado verde perfecto durante todo el año sin necesidad de riego, siega ni tratamientos químicos.',
    'garden.adv1': 'Aspecto natural durante todo el año',
    'garden.adv2': 'Sin necesidad de riego ni mantenimiento',
    'garden.adv3': 'Resistente a rayos UV y decoloración',
    'garden.adv4': 'Sistema de drenaje integrado',
    'garden.adv5': 'Seguro para niños y mascotas',
    'garden.adv6': 'Instalación rápida sobre cualquier superficie',
    'garden.app1.title': 'Residencial',
    'garden.app1.desc': 'Jardines, terrazas y áticos con un verde perfecto.',
    'garden.app2.title': 'Comercial',
    'garden.app2.desc': 'Áreas recreativas, hoteles y espacios públicos.',

    // Downloads Page - Category Titles
    'dl.cat.guides': 'Guías de instalación',
    'dl.cat.certs': 'Certificados y garantías',
    // Downloads Page - Document Names
    'dl.floor.cat1': 'Catálogo SmartFloor SPC Static Pro',
    'dl.floor.cat2': 'Catálogo SPC New Designs',
    'dl.panel.pvc.cat1': 'Catálogo PS Decor Pro Collection',
    'dl.panel.pvc.cat2': 'Catálogo PS Decor Pro Designs',
    'dl.panel.pvc.cat3': 'Catálogo SmartSlat Wood Collection',
    'dl.panel.pvc.cat4': 'Catálogo SmartSlat Design Collection',
    'dl.panel.spc.cat1': 'Catálogo SmartPanel Outdoor',
    'dl.panel.bambu.cat1': 'Catálogo SmartPanel Acoustic',
    'dl.panel.piedra.name': 'SmartPanel Porcelánico',
    'dl.panel.piedra.cat1': 'Catálogo SmartPanel Porcelánico',
    'dl.door.cat1': 'Catálogo SmartDoor WPC Waterproof',
    'dl.strips.cat1': 'Catálogo SmartStrips',
    'dl.sofa.cat1': 'Catálogo SmartSofa',
    'dl.machinery.cat1': 'Catálogo SmartMachinery',
    'dl.garden.cat1': 'Catálogo SmartGarden',
    'dl.general.name': 'Documentación General',
  },
  en: {
    // Navbar
    'nav.home': 'Home',
    'nav.catalog': 'Catalog',
    'nav.downloads': 'Documentation',
    'nav.company': 'Company',
    'nav.solutions': 'Solutions',
    'nav.seeAll': 'See all',

    // Footer
    'footer.desc':
      'SmartImport Internacional specializes in importing and distributing architectural materials for professional distributors and construction projects.',
    'footer.nav': 'Navigation',
    'footer.products': 'Product Lines',
    'footer.rights': 'SmartImport Internacional. All rights reserved.',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Use',
    'footer.legal': 'Legal Notice',
    'footer.cookies': 'Cookie Policy',

    // Home
    'home.hero.title': 'Architectural materials for distributors',
    'home.hero.desc':
      'We develop, manufacture and import materials for companies looking to expand or create their own product lines.',
    'home.hero.cta': 'Explore catalog',
    'home.hero.scroll': 'Discover',
    'home.solutions.title': 'Our Solutions',
    'home.solutions.floor.desc': 'SPC flooring and technical decking',
    'home.solutions.panel.desc': 'Decorative panels and wall coverings',
    'home.solutions.door.desc': 'WPC doors and access solutions',
    'home.solutions.strips.desc':
      'Panels, strips, and cladding for interior and exterior',
    'home.solutions.sofa.desc': 'Compact self-expanding sofas',
    'home.solutions.machinery.desc': 'Electric cargo lifts and elevators',
    'home.solutions.garden.desc': 'Artificial grass and exterior landscaping',
    'home.solutions.details': 'View details',
    'home.apps.title': 'Applications & Projects',
    'home.apps.desc':
      'Our materials are designed to adapt to the demands of any environment, offering durability and superior aesthetics.',
    'home.apps.hotels': 'Hotels',
    'home.apps.offices': 'Offices',
    'home.apps.residential': 'Residential',
    'home.apps.commercial': 'Commercial spaces',
    'home.catalog.title': 'Materials Catalog',
    'home.catalog.desc':
      'Explore our extensive collection of samples, textures, and finishes. Designed to inspire and materialize your architectural vision with the highest quality.',
    'home.catalog.cta': 'View full catalog',
    'home.why.title': 'Why SmartImport?',
    'home.why.q1.title': 'High quality',
    'home.why.q1.desc': 'Premium standards in every material.',
    'home.why.q2.title': 'Innovative materials',
    'home.why.q2.desc': 'Latest trends in design and technology.',
    'home.why.q3.title': 'International distribution',
    'home.why.q3.desc': 'Efficient and secure global logistics.',
    'home.why.q4.title': 'Professional solutions',
    'home.why.q4.desc': 'Expert advice for your project.',

    // Brand Development Section
    'home.brand.title': 'Brand development and manufacturing',
    'home.brand.desc':
      "At SmartImport, we don't just develop our own product lines. We also collaborate with distributors and companies looking to create or expand their own brands through manufacturing and direct import with specialized manufacturers.",
    'home.brand.b1.title': 'Custom manufacturing',
    'home.brand.b1.desc':
      'Production tailored to client needs through manufacturers specialized in architectural materials.',
    'home.brand.b2.title': 'Brand creation',
    'home.brand.b2.desc':
      'Brand identity development, packaging and catalog creation for private label product lines.',
    'home.brand.b3.title': 'Import and logistics',
    'home.brand.b3.desc':
      'Complete process management from manufacturing to delivery at the final destination.',

    // How We Work Section
    'home.how.title': 'How we work',
    'home.how.desc':
      'We manage the entire import and logistics process for architectural materials distributors.',
    'home.how.s1.title': 'Order reception',
    'home.how.s1.desc':
      'We receive orders and coordinate production with specialized manufacturers.',
    'home.how.s2.title': 'Warehousing',
    'home.how.s2.desc':
      'We manage the storage and organization of materials in modern logistics centers.',
    'home.how.s3.title': 'Quality control',
    'home.how.s3.desc':
      'Every batch of materials is inspected to ensure international standards.',
    'home.how.s4.title': 'Order preparation',
    'home.how.s4.desc':
      'We prepare and package products such as SPC flooring, decorative panels and profiles for distribution.',
    'home.how.s5.title': 'International shipping',
    'home.how.s5.desc':
      'We coordinate global shipments through containers and efficient international logistics.',

    // Distributor Solutions Section
    'home.dist.title': 'Solutions for distributors',
    'home.dist.desc':
      'SmartImport collaborates with distributors, specialized stores and companies looking to expand or develop new product lines through manufacturing and direct import.',
    'home.dist.p1': 'Development of customized product lines',
    'home.dist.p2': 'Private label manufacturing',
    'home.dist.p3': 'International import and distribution',
    'home.dist.partner.title': 'Trusted partner',
    'home.dist.partner.desc':
      'We work as an extension of your team, offering technical support, product development and comprehensive logistics management.',

    // Product Pages - Technical Documentation
    'prod.docs.title': 'Technical Documentation',
    'prod.docs.download': 'Download PDF',
    'prod.docs.soon': 'Coming soon',
    'prod.docs.floor.desc':
      'Access catalogs and technical data sheets for the SmartFloor SPC system.',
    'prod.docs.panel.desc':
      'Access catalogs and technical data sheets for the SmartPanel line.',
    'prod.docs.door.desc':
      'Access catalogs and technical data sheets for the SmartDoor line.',
    'prod.docs.alum.desc':
      'Access catalogs and technical data sheets for the SmartAluminium line.',

    // Solutions Page
    'sol.hero.title': 'Product Lines',
    'sol.hero.desc':
      'Comprehensive solutions for demanding architectural projects.',
    'sol.floor.desc':
      'Next-generation flooring that combines natural beauty with extreme resistance. Ideal for high-traffic areas, water-resistant, and easy to install.',
    'sol.panel.desc':
      'Innovative wall coverings that quickly transform spaces. They offer acoustic insulation, fire resistance, and a wide variety of aesthetic finishes.',
    'sol.door.desc':
      'Interior and exterior doors made with wood and polymer composites. They guarantee durability against moisture, modern design, and excellent thermal insulation.',
    'sol.strips.desc':
      'Decorative solutions and architectural cladding for interiors and exteriors, including PS panels, decorative strips, and high-durability WPC systems.',
    'sol.sofa.desc':
      'SmartSofa is an innovative seating solution designed for convenience and comfort. Each sofa is delivered in a compact package and expands to its full shape within hours. It combines modern design and easy setup.',
    'sol.machinery.desc':
      'SmartMachinery provides reliable electric lifting systems designed for transporting goods efficiently across different levels. Our solutions support various load capacities, including 2000 kg, 3000 kg, and 4000 kg, making them ideal for warehouses, logistics centers, and commercial facilities.',
    'sol.garden.desc':
      'Exterior and landscaping solutions with high-quality artificial grass. Ideal for gardens, terraces, recreational areas, and commercial spaces requiring a natural finish without maintenance.',
    'sol.explore': 'Explore full line',

    // Catalog Page
    'cat.hero.title': 'Materials Catalog',
    'cat.hero.desc': 'Explore our selection of premium finishes.',
    'cat.download.btn': 'Download catalog',
    'cat.c1.title': 'Luxury Series',
    'cat.c1.desc':
      'PVC decorative panel collection with glossy marble effect for premium interiors.',
    'cat.c2.title': 'Classic Series',
    'cat.c2.desc':
      'Classic PVC marble-effect panel collection for residential and commercial projects.',
    'cat.c3.title': 'Matte Series',
    'cat.c3.desc':
      'Decorative panels with matte finish inspired by natural stone for contemporary interiors.',
    'cat.c4.title': 'Gold Series',
    'cat.c4.desc':
      'Marble-effect decorative panels with gold veining for exclusive architectural projects.',
    'cat.c5.title': 'Matte Collection II',
    'cat.c5.desc':
      'Decorative panel collection with matte finishes and textures inspired by natural marble.',
    'cat.c16.title': 'Bambú Collection',
    'cat.c16.desc':
      'Eco-friendly bamboo panel collection with natural finishes for sustainable interiors.',
    'cat.c17.title': 'Sintered Stone Collection',
    'cat.c17.desc':
      'High-resistance sintered stone panels with premium porcelain-type finishes.',
    'cat.tabs.all': 'All',
    'cat.tabs.smartpanel': 'SmartPanel',
    'cat.tabs.smartstrips': 'SmartPanel Exterior & Decorativo',
    'cat.tabs.smartfloor': 'SmartFloor',
    'cat.tabs.smartdoor': 'SmartDoor',
    'cat.tabs.smartsofa': 'SmartSofa',
    'cat.tabs.smartmachinery': 'SmartMachinery',
    'cat.tabs.smartgarden': 'SmartGarden',
    'cat.c6.title': 'Decorative Wall Slats Collection',
    'cat.c6.desc':
      'Decorative wall slat collection with modern linear design for interior walls. Ideal for creating elegant architectural walls in residential and commercial spaces.',
    'cat.c7.title': 'PS Interior Wall Systems',
    'cat.c7.desc':
      'Modern PS decorative panel system for interior wall cladding and contemporary architectural surfaces. Designed for residential and commercial projects with premium finishes and modern aesthetics.',
    'cat.c8.title': 'SmartFloor SPC Static Pro',
    'cat.c8.desc':
      'High-resistance mineral SPC flooring system, 100% waterproof and designed for modern residential and commercial spaces.',
    'cat.c9.title': 'SPC New Designs Collection',
    'cat.c9.desc':
      'New SPC flooring designs collection with natural wood finishes and high performance for interior architecture projects.',
    'cat.c10.title': 'SmartDoor WPC Waterproof',
    'cat.c10.desc':
      'High-performance WPC interior doors, 100% waterproof, moisture-proof and fire-resistant. Designed for residential and commercial projects with modern aesthetics and great durability.',
    'cat.c18.title': 'Armored Doors',
    'cat.c18.desc':
      'High-security doors with reinforced structure, modern design and premium finishes. Ideal for main entrances in homes and residential projects.',
    'cat.c19.title': 'PS Decorative Mouldings',
    'cat.c19.desc':
      'Decorative PS mouldings for modern interior finishes, ideal for creating elegant details and contemporary architectural cladding in residential and commercial projects.',
    'cat.c20.title': 'WPC Exterior Decking',
    'cat.c20.desc':
      'Premium WPC decking and exterior surface system designed for terraces, facades, pools, and contemporary architectural projects. High durability, modern aesthetics, and luxury outdoor finishes for residential and commercial applications.',
    'cat.c21.title': 'PS Decorative Wall Panels',
    'cat.c21.desc':
      'Premium collection of PS decorative wall panels for interior wall cladding with three-dimensional designs and modern architectural finishes. Ideal for high-end residential and commercial projects.',
    'cat.c22.title': 'PS Wall Panel Catalog',
    'cat.c22.desc':
      'Premium PS decorative panel system for interior cladding and modern architectural applications with elegant finishes and contemporary design.',
    'cat.c11.title': 'SmartAluminium Window Systems',
    'cat.c11.desc':
      'High-performance aluminum window and door systems with minimalist profiles, double glazing and excellent thermal and acoustic insulation. Designed for modern architecture in homes, offices and commercial projects.',
    'cat.c12.title': 'SmartGarden Artificial Grass',
    'cat.c12.desc':
      'High-quality artificial grass designed for gardens, terraces and outdoor spaces. Natural appearance, high durability and minimal maintenance for residential and commercial projects.',
    'cat.c13.title': 'SmartSofa',
    'cat.c13.desc':
      'Sofás modulares de diseño premium con sistemas expansibles, pensados para maximizar el confort y la funcionalidad en espacios modernos.',
    'cat.c14.title': 'SmartMachinery',
    'cat.c14.desc':
      'Equipos de elevación como montacargas eléctricos y plataformas hidráulicas, diseñados para el manejo eficiente de mercancías en entornos industriales.',
    'cat.c15.title': 'SmartGarden',
    'cat.c15.desc':
      'Césped artificial y soluciones decorativas para exteriores, diseñadas para ofrecer durabilidad, estética natural y bajo mantenimiento.',
    'cat.coming.soon': 'Coming soon',
    'cat.viewAll.btn': 'View all catalogs',
    'cat.viewAll.subtitle':
      'Explore all collections and complete technical documentation',
    'cat.sample': 'Material Sample',
    'cat.item1.name': 'Natural Oak SPC',
    'cat.item1.desc': 'Matte wood finish, 5mm',
    'cat.item2.name': 'Dark Walnut SPC',
    'cat.item2.desc': 'Synchronized texture, 6mm',
    'cat.item3.name': 'Limestone SPC',
    'cat.item3.desc': 'Natural stone effect, large format',
    'cat.item4.name': 'Slatted Acoustic Panel',
    'cat.item4.desc': 'Wood on PET felt',
    'cat.item5.name': '3D Wave Cladding',
    'cat.item5.desc': 'Matte white lacquered finish',
    'cat.item6.name': 'Smooth White WPC Door',
    'cat.item6.desc': 'Solid core, water resistant',
    'cat.item7.name': 'Wood Texture WPC Door',
    'cat.item7.desc': 'Oak finish with matching frame',
    'cat.item8.name': 'Minimalist Black Profile',
    'cat.item8.desc': 'Matte black anodized, series 45',
    'cat.item9.name': 'Glass Office Division',
    'cat.item9.desc': 'Hidden profile, double glazing',
    'cat.item10.name': 'Premium Grass 40mm',
    'cat.item10.desc': 'High density, natural look',
    'cat.item11.name': 'Sports Grass 25mm',
    'cat.item11.desc': 'Resistant to heavy foot traffic',
    'cat.item12.name': 'Landscape Grass 35mm',
    'cat.item12.desc': 'Soft touch, integrated drainage',
    'cat.item15.name': 'Black WPC Door',
    'cat.item15.desc': 'Elegant black finish, solid core',
    'cat.item16.name': 'Slim Frame System',
    'cat.item16.desc': 'Ultra-thin profile, maximum luminosity',

    // Downloads Page
    'dl.hero.title': 'Documentation',
    'dl.hero.desc':
      'Technical documentation center for distributors and architects. Access data sheets, installation guides and product certificates.',
    'dl.sec1.title': 'Technical Data Sheets',
    'dl.sec1.desc':
      'Technical documentation with specifications, dimensions, materials and product performance.',
    'dl.sec1.i1': 'SPC Static Pro Data Sheet',
    'dl.sec1.i2': 'WPC Doors Specifications',
    'dl.sec1.i3': 'Aluminum Profiles – Details',
    'dl.sec1.i4': 'Anti-Slip Classification R11',
    'dl.sec1.i5': 'SPC Baseboard Data Sheet',
    'dl.sec2.title': 'Installation Guides',
    'dl.sec2.desc':
      'Technical manuals for the correct installation of systems and materials.',
    'dl.sec2.i1': 'Panel Installation Guide',
    'dl.sec2.i2': 'SPC Installation Manual',
    'dl.sec2.i3': 'WPC Installation Manual',
    'dl.panel.pvc.tech1': 'PVC 4mm Technical Data Sheet',
    'dl.panel.bambu.tech1': 'Bamboo Panel 3-Layer Technical Data Sheet',
    'dl.panel.bambu.tech2': 'Product 4mm Technical Data Sheet',
    'dl.door.wpc.cert1': 'WPC Doors Warranty Certificate',
    'dl.door.wpc.tech1': 'WPC Doors Technical Data Sheet',
    'dl.door.wpc.tech2': 'WPC Door Technical Data Sheet',
    'dl.door.blindada.tech1': 'Armored Door Technical Data Sheet',
    'dl.strips.tech1': 'PS Baseboard Technical Data Sheet',
    'dl.strips.tech2': 'PS Wall Panel Data Sheet',
    'dl.sec3.title': 'Certificates & Warranties',
    'dl.sec3.desc':
      'Quality certificates, standards compliance and product warranties.',
    'dl.sec3.i1': 'Fire Resistance Certificate',
    'dl.sec3.i2': 'ISO 9001 Certification',
    'dl.sec3.i3': 'SmartFloor 25-Year Warranty',
    'dl.btn': 'Download',

    // About Page
    'about.hero.title': 'About SmartImport',
    'about.hero.desc':
      'Specialists in the international import and distribution of cutting-edge architectural materials.',
    'about.vision.title': 'Our Vision',
    'about.vision.p1':
      'SmartImport Internacional was born with the purpose of connecting the most demanding architectural projects with innovative material solutions globally. We specialize in the import and distribution of high-end products, including WPC doors, SPC flooring, decorative panels, and aluminum systems.',
    'about.vision.p2':
      'We understand that contemporary architecture requires materials that not only meet the highest aesthetic standards but also offer superior technical performance, durability, and ease of installation.',
    'about.vision.p3':
      'Our team of experts carefully selects each product line, ensuring they meet rigorous international quality and sustainability standards, to offer architects, builders, and designers the necessary tools to materialize their vision.',
    'about.pillars.title': 'Our Pillars',
    'about.pillars.desc':
      'The values that guide our operation and guarantee excellence in every delivery.',
    'about.pil1.title': 'Innovation',
    'about.pil1.desc':
      'Constant search for new materials and construction technologies.',
    'about.pil2.title': 'Quality',
    'about.pil2.desc':
      'Strict controls and certifications on all our products.',
    'about.pil3.title': 'Global Reach',
    'about.pil3.desc':
      'Efficient and secure international distribution network.',
    'about.pil4.title': 'Professional Service',
    'about.pil4.desc': 'Specialized technical advice for every project.',

    // Product Pages Common
    'prod.line': 'Product Line',
    'prod.adv.title': 'Main Advantages',
    'prod.dl.btn': 'Download Technical Catalog',

    // SmartFloor
    'floor.hero.desc': 'High-performance SPC flooring and technical decking.',
    'floor.sec.title': 'Innovation under your feet',
    'floor.sec.p1':
      'The SmartFloor line represents the evolution in flooring. Manufactured with SPC (Stone Plastic Composite) technology, our floors offer superior dimensional stability and unmatched resistance to impacts and scratches.',
    'floor.sec.p2':
      'Ideal for both quick renovations and new construction, they provide the warm look of wood or the elegance of stone with the technical advantages of next-generation composite materials.',
    'floor.adv1': 'High durability and wear resistance',
    'floor.adv2': '100% water and moisture resistant',
    'floor.adv3': 'Fast installation via click system',
    'floor.adv4': 'Wide variety of realistic designs and textures',
    'floor.adv5': 'Easy maintenance and cleaning',
    'floor.adv6': 'Compatible with underfloor heating',
    'floor.app1.title': 'Residential',
    'floor.app1.desc':
      'Living rooms, kitchens, and bathrooms with a flawless finish.',
    'floor.app2.title': 'Commercial',
    'floor.app2.desc': 'High-traffic retail spaces, offices, and hotels.',

    // SmartFloor Technical Specs
    'floor.specs.title': 'SmartFloor SPC system technical characteristics',
    'floor.specs.intro':
      'The SmartFloor SPC system has been designed to offer high resistance, dimensional stability and durability in residential and commercial applications. Manufactured with SPC (Stone Plastic Composite) technology, it combines natural aesthetics with high technical performance.',
    'floor.specs.features.title': 'Key features',
    'floor.specs.f1': '100% waterproof, resistant to water and moisture',
    'floor.specs.f2': 'High wear resistance for high-traffic areas',
    'floor.specs.f3': 'Anti-slip surface for enhanced safety',
    'floor.specs.f4': 'High dimensional stability against temperature changes',
    'floor.specs.f5': 'Easy maintenance and cleaning',
    'floor.specs.f6': 'Suitable for residential and commercial applications',
    'floor.specs.table.title': 'Technical specifications',
    'floor.specs.table.col1': 'Feature',
    'floor.specs.table.col2': 'Specification',
    'floor.specs.t1.label': 'Floor type',
    'floor.specs.t1.value': 'SPC (Stone Plastic Composite)',
    'floor.specs.t2.label': 'Waterproofing',
    'floor.specs.t2.value': '100% water resistant',
    'floor.specs.t3.label': 'Wear resistance',
    'floor.specs.t3.value': 'Wear group T',
    'floor.specs.t4.label': 'Slip resistance',
    'floor.specs.t4.value': 'R9',
    'floor.specs.t5.label': 'Dimensional stability',
    'floor.specs.t5.value': 'High stability against expansion or contraction',
    'floor.specs.t6.label': 'Chemical resistance',
    'floor.specs.t6.value': 'Unaffected by more than 35 chemical products',
    'floor.specs.t7.label': 'Heat resistance',
    'floor.specs.t7.value': 'No deformation after heat exposure',
    'floor.specs.t8.label': 'Chemical emissions (VOC)',
    'floor.specs.t8.value': 'Meets CDPH/EHLB standard',
    'floor.specs.t9.label': 'Fire resistance',
    'floor.specs.t9.value': 'Meets EN ISO regulation',
    'floor.specs.t10.label': 'Recommended use',
    'floor.specs.t10.value': 'Residential and commercial applications',

    // SmartPanel
    'panel.hero.desc': 'Decorative panels and architectural wall coverings.',
    'panel.sec.title': 'Immediate visual transformation',
    'panel.sec.p1':
      'SmartPanel redefines interior design by offering wall covering solutions that combine premium aesthetics with technical functionality. Our panels allow commercial and residential spaces to be renovated in record time, avoiding complex construction work.',
    'panel.sec.p2':
      'From natural wood finishes to stone textures and three-dimensional designs, the collection provides architects and designers with a versatile tool to create unique atmospheres.',
    'panel.adv1': 'Aesthetic versatility with multiple textures',
    'panel.adv2': 'Fast installation over existing walls',
    'panel.adv3': 'Acoustic insulation properties',
    'panel.adv4': 'Fire resistance (B-s1,d0 certification)',
    'panel.adv5': 'Easy maintenance and cleaning',
    'panel.adv6': 'Lightweight yet highly resistant material',
    'panel.app1.title': 'Hospitality',
    'panel.app1.desc': 'Lobbies, rooms, and restaurants with exclusive design.',
    'panel.app2.title': 'Corporate',
    'panel.app2.desc': 'High-impact meeting rooms and reception areas.',

    // SmartDoor
    'door.hero.desc': 'WPC doors and advanced access solutions.',
    'door.sec.title': 'Accesses that make a difference',
    'door.sec.p1':
      'SmartDoor doors, made of WPC (Wood Plastic Composite), represent the ultimate alternative to traditional wooden doors. They combine aesthetic warmth with superior structural strength, being totally immune to moisture and wood-boring insects.',
    'door.sec.p2':
      'Their solid core provides excellent acoustic insulation, making them ideal for hotel, residential, and hospital projects where comfort and durability are priorities.',
    'door.adv1': '100% resistant to water and moisture',
    'door.adv2': 'High durability and impact resistance',
    'door.adv3': 'Excellent thermal and acoustic insulation',
    'door.adv4': 'Modern and minimalist designs',
    'door.adv5': 'No complex maintenance required',
    'door.adv6': 'Ecological and recyclable',
    'door.app1.title': 'Healthcare',
    'door.app1.desc':
      'Demanding environments requiring hygiene and resistance.',
    'door.app2.title': 'Residential',
    'door.app2.desc': 'Bathrooms and wet areas with no risk of deterioration.',

    // SmartStrips
    'strips.hero.desc':
      'Decorative solutions and cladding for interiors and exteriors.',
    'strips.sec.title': 'Cladding that transforms spaces',
    'strips.sec.p1':
      'Our line of decorative solutions ranges from interior strips and PS panels to WPC decking and architectural cladding for exteriors. They provide a modern aesthetic while being easy to install and maintain, ideal for any environment.',
    'strips.sec.p2':
      'Available in a wide range of finishes and materials, these solutions allow you to create unique compositions that add depth, texture, and personality to both interiors and outdoor facades or spaces.',
    'strips.adv1': 'Quick and easy installation',
    'strips.adv2': 'Wide variety of finishes and colors',
    'strips.adv3': 'Resistant to moisture and wear',
    'strips.adv4': 'Solutions for interior and exterior',
    'strips.adv5': 'Minimal maintenance',
    'strips.adv6': 'High-durability WPC systems',
    'strips.app1.title': 'Decorative Interior',
    'strips.app1.desc':
      'PS panels and strips for living rooms, bedrooms, and design spaces.',
    'strips.app2.title': 'Architectural Exterior',
    'strips.app2.desc':
      'WPC decking and cladding for facades, terraces, and commercial spaces.',

    // SmartSofa
    'sofa.hero.desc': 'Compact sofas with self-expanding system.',
    'sofa.sec.title': 'Smart comfort',
    'sofa.sec.p1':
      'SmartSofa is an innovative seating solution designed for convenience and comfort. Each sofa is delivered in a compact package and expands to its full shape within hours after unpacking.',
    'sofa.sec.p2':
      'It combines practicality, modern design, and easy setup, making it ideal for contemporary living spaces. No tools, no hassle, just immediate comfort.',
    'sofa.adv1': 'Self-expanding system, no tools needed',
    'sofa.adv2': 'Delivered in a compact package',
    'sofa.adv3': 'Modern and ergonomic design',
    'sofa.adv4': 'High-quality, durable materials',
    'sofa.adv5': 'Easy cleaning and maintenance',
    'sofa.adv6': 'Ideal for contemporary spaces',
    'sofa.app1.title': 'Residential',
    'sofa.app1.desc': 'Modern living rooms and living spaces.',
    'sofa.app2.title': 'Hospitality',
    'sofa.app2.desc': 'Hotels, tourist apartments, and coworking.',

    // SmartMachinery
    'machinery.hero.desc':
      'Electric cargo lift solutions for industrial and commercial use.',
    'machinery.sec.title': 'Efficient and safe lifting',
    'machinery.sec.p1':
      'SmartMachinery provides reliable electric lifting systems designed for transporting goods efficiently across different levels. Our solutions support various load capacities, including 2000 kg, 3000 kg, and 4000 kg.',
    'machinery.sec.p2':
      'Ideal for warehouses, logistics centers, and commercial facilities, our cargo lifts combine industrial robustness with easy installation and maintenance.',
    'machinery.adv1': 'High load capacity (2000–4000 kg)',
    'machinery.adv2': 'Smooth and safe operation',
    'machinery.adv3': 'Industrial-grade durability',
    'machinery.adv4': 'Easy installation and maintenance',
    'machinery.adv5': 'Efficient electric systems',
    'machinery.adv6': 'Safety regulation compliance',
    'machinery.app1.title': 'Industrial',
    'machinery.app1.desc': 'Warehouses, factories, and logistics centers.',
    'machinery.app2.title': 'Commercial',
    'machinery.app2.desc': 'Shopping centers, hotels, and office buildings.',

    // SmartGarden
    'garden.hero.desc':
      'Exterior and landscaping solutions with high-quality artificial grass.',
    'garden.sec.title': 'Nature without maintenance',
    'garden.sec.p1':
      'The SmartGarden line offers next-generation artificial grass, designed to replicate the appearance and texture of natural grass with exceptional durability. Made with high-density polyethylene fibers, our grass resists UV radiation, heavy foot traffic, and the most demanding weather conditions.',
    'garden.sec.p2':
      "Ideal for residential gardens, terraces, children's play areas, sports facilities, and commercial spaces. It provides a perfect green finish all year round without the need for watering, mowing, or chemical treatments.",
    'garden.adv1': 'Natural look all year round',
    'garden.adv2': 'No watering or maintenance required',
    'garden.adv3': 'UV resistant and fade-proof',
    'garden.adv4': 'Integrated drainage system',
    'garden.adv5': 'Safe for children and pets',
    'garden.adv6': 'Quick installation on any surface',
    'garden.app1.title': 'Residential',
    'garden.app1.desc': 'Gardens, terraces, and rooftops with a perfect green.',
    'garden.app2.title': 'Commercial',
    'garden.app2.desc': 'Recreational areas, hotels, and public spaces.',

    // Shared Documentation Section Keys
    'prod.docs.catalogs': 'Catalogs',
    'prod.docs.techDocs': 'Technical Documentation',
    'prod.docs.techSheets': 'Technical Data Sheets',
    'prod.docs.count.one': 'document',
    'prod.docs.count.many': 'documents',

    // SmartPanel Materials Section
    'prod.docs.panel.title': 'SmartPanel Materials',
    'prod.docs.panel.materials.desc':
      'Access catalogs, technical data sheets and certificates for each material.',
    'panel.pvc.name': 'SmartPanel PVC',
    'panel.pvc.desc':
      'Lightweight and versatile decorative panel, ideal for multiple interior applications.',
    'panel.spc.name': 'SmartPanel SPC',
    'panel.spc.desc':
      'High-resistance panel with great stability, perfect for demanding spaces.',
    'panel.bambu.name': 'SmartPanel Bamboo',
    'panel.bambu.desc':
      'Eco-friendly panel with natural finish, includes bamboo charcoal solutions.',
    'panel.piedra.name': 'SmartPanel Sintered Stone',
    'panel.piedra.desc':
      'Maximum resistance panel with premium porcelain-type finish.',
    'panel.pvc.cat1': 'Classic Series Glossy PVC Marble 2024',
    'panel.pvc.cat2': 'Gilded Series Glossy PVC Marble 2024',
    'panel.pvc.cat3': 'Luxury Series Glossy PVC Marble 2024',
    'panel.pvc.cat4': 'Matte Collection Vol. 1',
    'panel.pvc.cat5': 'Matte Collection Vol. 2',
    'panel.pvc.tech1': 'SmartPanel PVC – Technical Data Sheet 4mm',
    'panel.bambu.cat1': 'Bamboo Collection Vol. 1',
    'panel.bambu.cat2': 'Bamboo Collection Vol. 2',
    'panel.bambu.cat3': 'Bamboo Premium Designs',
    'panel.bambu.cat4': 'Bamboo Natural Series',
    'panel.bambu.cat5': 'Bamboo Interior Collection',
    'panel.bambu.cat6': 'Bamboo Modern Line',
    'panel.bambu.cat7': 'Bamboo Architectural Systems',
    'panel.bambu.cat8': 'Bamboo Decorative Panels',
    'panel.bambu.cat9': 'Bamboo Technical Overview',
    'panel.bambu.cat10': 'Bamboo Installation Guide',
    'panel.bambu.cat11': 'Bamboo Specifications Sheet',
    'panel.bambu.cat12': 'Bamboo Luxury Stone Collection',
    'panel.bambu.tech1': 'Bamboo Technical Data Sheet',
    'panel.piedra.cat1': 'Sintered Stone – Full Collection 2025',
    'panel.piedra.cat2': 'Sintered Stone – Glossy Finish',
    'panel.piedra.cat3': 'Sintered Stone – Matte Finish',
    'panel.piedra.cat4': 'Sintered Stone – Soft Touch Finish',
    'panel.piedra.cat5': 'Sintered Stone – Textured Surface',
    'panel.piedra.cat6': 'Sintered Stone – Digital Surface',
    'panel.piedra.tech1': 'Technical Documentation',

    // SmartStrips Documentation Section
    'prod.docs.strips.title': 'SmartPanel Exterior & Decorativo Documentation',
    'prod.docs.strips.desc':
      'Access catalogs and technical data sheets for panels, strips, and cladding.',
    'strips.cat1': 'Decorative Strips – Catalog 1',
    'strips.cat2': 'Decorative Strips – Catalog 2',
    'strips.cat3': 'Decorative Strips – Luxury Catalog',
    'strips.tech1': 'Decorative Strips – Technical Data Sheet',

    // SmartMachinery Documentation Section
    'prod.docs.machinery.title': 'SmartMachinery Documentation',
    'prod.docs.machinery.desc':
      'Access catalogs and technical documentation for SmartMachinery.',
    'machinery.cat1': 'Electric Cargo Lifts Catalogue',

    // SmartSofa Documentation Section
    'prod.docs.sofa.title': 'SmartSofa Documentation',
    'prod.docs.sofa.desc':
      'Access catalogs and technical documentation for SmartSofa.',
    'sofa.cat1': 'SmartSofa Collection Catalogue',

    // Catalog Page - New Cards
    'cat.c13.title': 'SmartSofa',
    'cat.c13.desc':
      'Premium modular sofas with expandable systems, designed to maximize comfort and functionality in modern spaces.',
    'cat.c14.title': 'SmartMachinery',
    'cat.c14.desc':
      'Lifting equipment such as electric forklifts and hydraulic platforms, designed for efficient goods handling in industrial environments.',
    'cat.c15.title': 'SmartGarden',
    'cat.c15.desc':
      'Artificial grass and decorative outdoor solutions, designed to offer durability, natural aesthetics and low maintenance.',

    // Downloads Page - Category Titles
    'dl.cat.guides': 'Installation Guides',
    'dl.cat.certs': 'Certificates & Warranties',
    // Downloads Page - Document Names
    'dl.floor.cat1': 'SmartFloor SPC Static Pro Catalog',
    'dl.floor.cat2': 'SPC New Designs Catalog',
    'dl.panel.pvc.cat1': 'PS Decor Pro Collection Catalog',
    'dl.panel.pvc.cat2': 'PS Decor Pro Designs Catalog',
    'dl.panel.pvc.cat3': 'SmartSlat Wood Collection Catalog',
    'dl.panel.pvc.cat4': 'SmartSlat Design Collection Catalog',
    'dl.panel.spc.cat1': 'SmartPanel Outdoor Catalog',
    'dl.panel.bambu.cat1': 'SmartPanel Acoustic Catalog',
    'dl.panel.piedra.name': 'SmartPanel Porcelain',
    'dl.panel.piedra.cat1': 'SmartPanel Porcelain Catalog',
    'dl.door.cat1': 'SmartDoor WPC Waterproof Catalog',
    'dl.strips.cat1': 'SmartStrips Catalog',
    'dl.sofa.cat1': 'SmartSofa Catalog',
    'dl.machinery.cat1': 'SmartMachinery Catalog',
    'dl.garden.cat1': 'SmartGarden Catalog',
    'dl.general.name': 'General Documentation',
  },
}
